import SeoSection from './components/SeoSection'

const VueYoastSeo = {
  install (Vue, options) {
    Vue.component(SeoSection.name, SeoSection)
  }
}

export default VueYoastSeo
